import { Table, TableColumnsType } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getDashboardPT } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IGetDashboardPT } from "../../../models/dashboard.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Subtitle from "./Subtitle";

const PT = () => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetDashboardPT>();

  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (currentCampus) {
      execute(getDashboardPT(currentCampus));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (res && !isLoading) {
      setData([
        {
          title: t('class.dashboard.column22'),
          reservationCount: res.data.todayInfo.reservationCount,
          completeCount: res.data.todayInfo.completeCount,
          registerCount: res.data.todayInfo.registerCount,
          registRate: res.data.todayInfo.registRate,
        },
        {
          title: t('class.dashboard.column23'),
          reservationCount: res.data.totalInfo.reservationCount,
          completeCount: res.data.totalInfo.completeCount,
          registerCount: res.data.totalInfo.registerCount,
          registRate: res.data.totalInfo.registRate,
        },
      ]);
    }
  }, [res, isLoading]);

  const columns: TableColumnsType<any> = [
    {
      title: '',
      dataIndex: 'title',
      key: 'title',
      align: 'center',
    },
    {
      title: t('class.dashboard.column24'),
      dataIndex: 'reservationCount',
      key: 'reservationCount',
      align: 'center',
      render: value => (value || value === 0) ? value : '-',
    },
    {
      title: t('class.dashboard.column25'),
      dataIndex: 'completeCount',
      key: 'completeCount',
      align: 'center',
      render: value => (value || value === 0) ? value : '-',
    },
    {
      title: t('class.dashboard.column26'),
      dataIndex: 'registerCount',
      key: 'registerCount',
      align: 'center',
      render: value => (value || value === 0) ? value : '-',
    },
    {
      title: t('class.dashboard.column27'),
      dataIndex: 'registRate',
      key: 'registRate',
      align: 'center',
      render: value => (value || value === 0) ? `${value}%` : '-',
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <Subtitle
        text={t('class.dashboard.title10')}
        path="/statistics/placement-test"
      />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={data}
        rowClassName={(record: any) => record.title === t('class.dashboard.column23') ? 'chosen' : 'pointer'}
      />
    </>
  );
}

export default PT;
